import React from "react";

import Box from "@mui/material/Box";
import Pagination from "@mui/material/Pagination";
import { useMediaQuery } from "@mui/material";
import RowsPerPageSelect from "./RowsPerPageSelect";

interface PaginationProps {
  id: string;
  pageSize?: number;
  pageCount: number;
  pageNumber: number;
  onPageChange: (page: number) => void;
  onPageSizeChange?: (pageSize: number) => void;
}

const ExtendedPagination = (props: PaginationProps) => {
  const {
    id,
    pageSize,
    pageCount,
    pageNumber,
    onPageChange,
    onPageSizeChange,
  } = props;

  const isNarrow = useMediaQuery("(max-width: 400px)");
  const isMobile = useMediaQuery("(max-width: 600px)");

  return (
    <Box
      sx={{
        width: "100%",
        display: "flex",
        flexWrap: "wrap",
        alignItems: "center",
        justifyContent: pageSize ? "space-between" : "center",
        rowGap: 3,
        mt: 3,
      }}
    >
      {pageSize && onPageSizeChange && (
        <RowsPerPageSelect
          rowsPerPage={pageSize}
          onRowsPerPageChange={onPageSizeChange}
        />
      )}
      <Pagination
        sx={{ mx: isNarrow ? "auto" : 0 }}
        key={id}
        count={pageCount}
        page={pageNumber}
        siblingCount={isMobile ? 0 : 1}
        onChange={(event: React.ChangeEvent<unknown>, value: number) => {
          onPageChange(value);
        }}
        color="primary"
      />
    </Box>
  );
};

export default ExtendedPagination;
